import { INTENSIVE_REVIEWS } from "./intensiveReviews";

/** CMS page tags used to filter reviews for intensive-english-v2 (revamp page) */
export const PAGE_FILTER_TAGS = [
  "intensive-new-v3",
  "intensive-new-v2",
  "intensive-new",
];

/** Tab order for recently placed section (newest first) */
export const PLACED_MONTH_TABS = [
  { month: "Jun", year: 2026, label: "Jun'26", key: "Jun-2026" },
  { month: "May", year: 2026, label: "May'26", key: "May-2026" },
  { month: "Apr", year: 2026, label: "Apr'26", key: "Apr-2026" },
  { month: "Mar", year: 2026, label: "Mar'26", key: "Mar-2026" },
  { month: "Feb", year: 2026, label: "Feb'26", key: "Feb-2026" },
  { month: "Jan", year: 2026, label: "Jan'26", key: "Jan-2026" },
  { month: "Dec", year: 2025, label: "Dec'25", key: "Dec-2025" },
];

const TAG_FIELD = "Page-specific filters Tags";

function parseTags(review) {
  return (review[TAG_FIELD] || "")
    .split(";")
    .map((t) => t.trim())
    .filter(Boolean);
}

export function reviewHasPageTag(review, tag) {
  return parseTags(review).includes(tag);
}

export function isPublishedReview(review) {
  return review.Draft !== "true" && review.Archived !== "true";
}

export function getReviewsForPage(tags = PAGE_FILTER_TAGS) {
  const published = INTENSIVE_REVIEWS.filter(isPublishedReview);
  for (const tag of tags) {
    const matched = published.filter((r) => reviewHasPageTag(r, tag));
    if (matched.length > 0) return matched;
  }
  return published;
}

export function getGraduationYear(review) {
  const year = review["Graduate year"];
  if (year == null || year === "") return "";
  return String(year).trim();
}

/** Before label: shortened degree only (not college name) */
export function getShortenedDegree(review) {
  return (review["Shortened Degree"] || "").trim();
}

export function getPlacedMonthMeta(review) {
  const dateStr = review["Placed month Date Formate"];
  const placedDate = dateStr ? new Date(dateStr) : null;
  const month = review["Placed Month"] || placedDate?.toLocaleString("en", { month: "short" }) || "";
  const year = placedDate?.getFullYear() || Number(review["Graduate year"]) || "";
  const yearSuffix = year ? String(year).slice(-2) : "";
  const label = yearSuffix ? `${month}'${yearSuffix}` : month;
  const key = `${month}-${year}`;
  return {
    key,
    label,
    month,
    year,
    sortTime: placedDate?.getTime() ?? 0,
  };
}

const MONTH_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function reviewMatchesPlacedTab(review, tab) {
  const dateStr = review["Placed month Date Formate"];
  if (!dateStr) return false;
  const placedDate = new Date(dateStr);
  if (Number.isNaN(placedDate.getTime())) return false;
  const month = MONTH_SHORT[placedDate.getMonth()];
  const year = placedDate.getFullYear();
  return month === tab.month && year === tab.year;
}

/** Groups reviews into the five fixed month tabs for v3 */
export function groupReviewsByPlacedMonthTabs(reviews, tabs = PLACED_MONTH_TABS) {
  return tabs.map((tab) => ({
    ...tab,
    reviews: reviews.filter((review) => reviewMatchesPlacedTab(review, tab)),
  }));
}
